import { render, staticRenderFns } from "./CommonSearch.vue?vue&type=template&id=1c908711&scoped=true"
import script from "./CommonSearch.vue?vue&type=script&lang=js"
export * from "./CommonSearch.vue?vue&type=script&lang=js"
import style0 from "./CommonSearch.vue?vue&type=style&index=0&id=1c908711&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c908711",
  null
  
)

export default component.exports